import { filter, takeUntil } from 'rxjs/operators';
import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-restriction',
  templateUrl: './restriction.component.html',
  styleUrls: ['./restriction.component.scss']
})
export class RestrictionComponent implements OnDestroy {

  private readonly subscriptionPlanSelectionRoute = '/subscription/plan-selection';


  url = '';
  sanitizedUrl = '';


  data:any;

  constructor(private router: Router,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<RestrictionComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
  ) {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
      this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
        this.url = this.router.url || '';
        this.sanitizedUrl = this.sanitizeUrl(this.url);
      });

    this.data = data
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
  }


  routerUrl:any= '/subscription/plan-selection';

  title:any;

  discription:any;

  button:any = 'Upgrade Now';


  ngOnInit(): void {

    this.routerUrl = this.data.router;

    this.title = this.data.title;

    this.discription = this.data.discription;

    this.button = this.data.button;
  }


  upgrade() {
    const target = String(this.routerUrl || '').trim() || this.subscriptionPlanSelectionRoute;
    this.router.navigateByUrl(target.startsWith('/') ? target : `/${target}`);
    this.dialog.closeAll();
  }




  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}

